import { render, staticRenderFns } from "./PaymentUsingDifferentCard.vue?vue&type=template&id=28da65c6&scoped=true"
import script from "./PaymentUsingDifferentCard.vue?vue&type=script&lang=js"
export * from "./PaymentUsingDifferentCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentUsingDifferentCard.vue?vue&type=style&index=0&id=28da65c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da65c6",
  null
  
)

export default component.exports